import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full max-w-full p-4 overflow-hidden rounded" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-2 text-xl" }
const _hoisted_5 = { class: "mb-2 text-xl" }
const _hoisted_6 = { class: "text-xs text-gray-500" }
const _hoisted_7 = { class: "mb-2 text-xs text-gray-500" }
const _hoisted_8 = { class: "mb-4 text-sm" }
const _hoisted_9 = {
  key: 1,
  class: "italic"
}
const _hoisted_10 = {
  key: 2,
  class: "italic"
}
const _hoisted_11 = { class: "mb-4 text-sm" }
const _hoisted_12 = {
  key: 1,
  class: "italic"
}
const _hoisted_13 = {
  key: 2,
  class: "italic"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "mb-2" }, "Comments", -1)
const _hoisted_16 = { class: "pb-12 h-2/5" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Done")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_algolia_search_component = _resolveComponent("algolia-search-component")
  const _component_algolia_correction_search_component = _resolveComponent("algolia-correction-search-component")
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.event.name), 1),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.maneuver.mif.unFormattedManeuver), 1),
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.event.date)), 1),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.event.title), 1)
      ]),
      (_ctx.maneuver.grade)
        ? (_openBlock(), _createBlock(_component_icon_component, {
            key: 0,
            class: "w-10 h-10 ml-auto",
            icon: _ctx.GradeIconMap.get(_ctx.maneuver.grade)
          }, null, 8, ["icon"]))
        : (_openBlock(), _createBlock(_component_icon_component, {
            key: 1,
            class: "w-10 h-10 ml-auto",
            icon: _ctx.GradeIconMap.get('NONE')
          }, null, 8, ["icon"]))
    ]),
    _createVNode(_component_algolia_search_component, {
      onSelectedItemEvent: _ctx.onSelectedRecommendation,
      onEnterPress: _ctx.onReasonInputEnterPressed,
      datatestId: `reason-search-component`,
      onKeyPress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInputChange($event, 'reason'))),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInputChange($event.target.value, 'reason'))),
      searchClient: _ctx.searchClient,
      algoliaIndex: _ctx.reasonIndex,
      optionalFiltersManeuverKeys: _ctx.optionalFiltersManeuverKeys,
      class: "mb-4",
      "data-testid": "maneuver-reason-search"
    }, null, 8, ["onSelectedItemEvent", "onEnterPress", "searchClient", "algoliaIndex", "optionalFiltersManeuverKeys"]),
    _createVNode("div", _hoisted_8, [
      (_ctx.reasonCharacterCount)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: ["float-right ml-4 text-sm", {
          'text-red-600': _ctx.reasonCharacterCount > _ctx.reasonMaxLength
        }]
          }, _toDisplayString(_ctx.reasonCharacterCount) + "/" + _toDisplayString(_ctx.reasonMaxLength), 3))
        : _createCommentVNode("", true),
      (!_ctx.reasons || !_ctx.reasons.length)
        ? (_openBlock(), _createBlock("div", _hoisted_9, " Select a reason "))
        : (_openBlock(), _createBlock("div", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reasons, (reason, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex p-4 mb-2 border rounded bg-primary-dark",
                key: index
              }, [
                _createTextVNode(_toDisplayString(reason.display) + " ", 1),
                _createVNode("button", {
                  class: "pl-2 ml-auto ocus:outline-none",
                  onClick: ($event: any) => (_ctx.removeReason(reason))
                }, " ✖ ", 8, ["onClick"])
              ]))
            }), 128))
          ]))
    ]),
    _createVNode(_component_algolia_correction_search_component, {
      onEnterPress: _ctx.onCorrectionInputEnterPressed,
      onSelectedItemEvent: _ctx.onSelectedCorrection,
      datatestId: `correction-search-component`,
      onKeyPress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInputChange($event, 'correction'))),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInputChange($event.target.value, 'correction'))),
      searchClient: _ctx.searchClient,
      algoliaIndex: _ctx.correctionIndex,
      optionalFiltersReasonKeys: _ctx.optionalFiltersReasonKeys,
      class: "mb-4",
      "data-testid": "maneuver-correction-search"
    }, null, 8, ["onEnterPress", "onSelectedItemEvent", "searchClient", "algoliaIndex", "optionalFiltersReasonKeys"]),
    _createVNode("div", _hoisted_11, [
      (_ctx.correctionCharacterCount)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: ["float-right ml-4 text-sm", {
          'text-red-600': _ctx.correctionCharacterCount > _ctx.correctionMaxLength
        }]
          }, _toDisplayString(_ctx.correctionCharacterCount) + "/" + _toDisplayString(_ctx.correctionMaxLength), 3))
        : _createCommentVNode("", true),
      (!_ctx.corrections || !_ctx.corrections.length)
        ? (_openBlock(), _createBlock("div", _hoisted_12, " Select a recommendation "))
        : (_openBlock(), _createBlock("div", _hoisted_13, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.corrections, (correction, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex p-4 mb-2 border rounded bg-primary-dark",
                key: index
              }, [
                (correction.key && correction.key !== '')
                  ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(correction.display), 1))
                  : _createCommentVNode("", true),
                _createVNode("button", {
                  class: "pl-2 ml-auto focus:outline-none",
                  onClick: ($event: any) => (_ctx.removeCorrection(correction))
                }, " ✖ ", 8, ["onClick"])
              ]))
            }), 128))
          ]))
    ]),
    _hoisted_15,
    _createVNode("div", _hoisted_16, [
      _createVNode("textarea", {
        class: "flex w-full h-full p-2 mb-4 text-sm border rounded resize-none",
        "data-testid": "maneuver-comments",
        value: _ctx.comment,
        onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateComments($event.target.value))),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInputChange($event.target.value, 'comments')))
      }, null, 40, ["value"]),
      (_ctx.commentCharacterCount)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: ["float-right text-sm", {
          'text-red-600': _ctx.commentCharacterCount > _ctx.commentMaxLength
        }]
          }, _toDisplayString(_ctx.commentCharacterCount) + "/" + _toDisplayString(_ctx.commentMaxLength), 3))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode(_component_button_component, {
        onClick: _ctx.handleCancel,
        class: "pr-4 ml-auto text-sm cursor-pointer"
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}